<template>
  <div class="main" id="previewPage">
    <div class="top_native" :style="{ backgroundImage: 'url(' + topNativeSrc + ')' }">
      <div class="newTitle animate__animated animate__zoomIn">
        <span :style="newTitleStyle">{{ this.newTitle ? this.newTitle : '资讯动态' }}</span>
      </div>
    </div>
    <div class="navBar">
      <div class="menu">
        <div class="menuItem" @click="active_index = 0" :class="active_index == 0 ? 'active' : ''">
          <span :style="menuItemTitle1Style">{{ this.menuItemTitle1 ? this.menuItemTitle1 : '市场动态' }}</span> /
          <span :style="menuItemTitle2Style">{{ this.menuItemTitle2 ? this.menuItemTitle2 : 'Market Dynamics' }}</span>
        </div>
        <div class="menuItem" @click="active_index = 1" :class="active_index == 1 ? 'active' : ''">
          <span :style="menuItemTitle3Style">{{ this.menuItemTitle3 ? this.menuItemTitle3 : '公司活动' }}</span> /
          <span :style="menuItemTitle4Style">{{ this.menuItemTitle4 ? this.menuItemTitle4 : 'Company Activities' }}</span>
        </div>
      </div>
    </div>
    <div class="newsList">
      <div v-if="active_index == 0">
        <div class="example" v-for="(item, index) in listData" :key="item.title">
          <img :src="item.urlImg" />
          <div class="rightCont">
            <div class="newTitle">
              <div>
                <img src="@/assets/img/icon/list.png" />
                <span>{{ item.title }}</span>
              </div>
              <div class="time">{{ item.date }}</div>
            </div>
            <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ item.message }}</p>
            <el-button @click="openNews(item.url)">查看详情</el-button>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="example" v-for="(item, index) in listData2" :key="item.title">
          <img :src="item.urlImg" />
          <div class="rightCont">
            <div class="newTitle">
              <div>
                <img src="@/assets/img/icon/list.png" />
                <span>{{ item.title }}</span>
              </div>
              <div class="time">{{ item.date }}</div>
            </div>
            <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ item.message }}</p>
            <el-button @click="openNews(item.url)">查看详情</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import watermark from '@/utils/watermark.js';
// import watermark from 'watermarkjs';
export default {
  name: "News",
  data() {
    return {
      active_index: 0,
      newTitle: '',
      menuItemTitle1: '',
      menuItemTitle2: '',
      menuItemTitle3: '',
      menuItemTitle4: '',
      menuItemTitle1Style: {},
      menuItemTitle2Style: {},
      menuItemTitle3Style: {},
      menuItemTitle4Style: {},
      newTitleStyle: {},
      topNativeSrc: require('../../assets/img/news/back.jpg'),
      // 市场动态资讯
      listData: [],
      // 公司活动资讯
      listData2: [],
    };
  },
  mounted() {
    window.scrollTo(0, 0);
    console.log(this.$route.query.type);
    if (this.$route.query.type == "market") {
      this.active_index = 0;
    } else if (this.$route.query.type == "activity") {
      this.active_index = 1;
    }


    if (sessionStorage.getItem('listData2') && sessionStorage.getItem('listData2') != 'undefined' && sessionStorage.getItem('listData2') != 'null') {
      this.listData2 = JSON.parse(sessionStorage.getItem('listData2'))
    }
    if (sessionStorage.getItem('listData') && sessionStorage.getItem('listData') != 'undefined' && sessionStorage.getItem('listData') != 'null') {

      this.listData = JSON.parse(sessionStorage.getItem('listData'))
    }
    if (sessionStorage.getItem('newTitle')) {
      this.newTitle = sessionStorage.getItem('newTitle');
    }
    if (sessionStorage.getItem('menuItemTitle1')) {
      this.menuItemTitle1 = sessionStorage.getItem('menuItemTitle1');
    }
    if (sessionStorage.getItem('menuItemTitle2')) {
      this.menuItemTitle2 = sessionStorage.getItem('menuItemTitle2');
    }
    if (sessionStorage.getItem('menuItemTitle3')) {
      this.menuItemTitle3 = sessionStorage.getItem('menuItemTitle3');
    }
    if (sessionStorage.getItem('menuItemTitle4')) {
      this.menuItemTitle4 = sessionStorage.getItem('menuItemTitle4');
    }

    if (sessionStorage.getItem('newTitleStyle') && sessionStorage.getItem('newTitleStyle') != 'undefined' && sessionStorage.getItem('newTitleStyle') != 'null') {
      this.newTitleStyle = JSON.parse(sessionStorage.getItem('newTitleStyle'));
    }
    if (sessionStorage.getItem('menuItemTitle1Style') && sessionStorage.getItem('menuItemTitle1Style') != 'undefined' && sessionStorage.getItem('menuItemTitle1Style') != 'null') {
      this.menuItemTitle1Style = JSON.parse(sessionStorage.getItem('menuItemTitle1Style'));
    }
    if (sessionStorage.getItem('menuItemTitle2Style') && sessionStorage.getItem('menuItemTitle2Style') != 'undefined' && sessionStorage.getItem('menuItemTitle2Style') != 'null') {
      this.menuItemTitle2Style = JSON.parse(sessionStorage.getItem('menuItemTitle2Style'));
    }
    if (sessionStorage.getItem('menuItemTitle3Style') && sessionStorage.getItem('menuItemTitle3Style') != 'undefined' && sessionStorage.getItem('menuItemTitle3Style') != 'null') {
      this.menuItemTitle3Style = JSON.parse(sessionStorage.getItem('menuItemTitle3Style'));
    }
    if (sessionStorage.getItem('menuItemTitle4Style') && sessionStorage.getItem('menuItemTitle4Style') != 'undefined' && sessionStorage.getItem('menuItemTitle4Style') != 'null') {
      this.menuItemTitle4Style = JSON.parse(sessionStorage.getItem('menuItemTitle4Style'));
    }

    if (sessionStorage.getItem('newTitleStyle') && sessionStorage.getItem('newTitleStyle') != 'undefined' && sessionStorage.getItem('newTitleStyle') != 'null') {
      this.newTitleStyle = JSON.parse(sessionStorage.getItem('newTitleStyle'));
    }

    if (sessionStorage.getItem('topNativeSrc')) {
      this.topNativeSrc = sessionStorage.getItem('topNativeSrc');
    }


    watermark.set('预览   预览  预览')//添加水印


  },
  destroyed() {
    watermark.set('')//去除水印
  },
  methods: {
    openNews(url) {
      window.open(url);
    },



  },
};
</script>

<style lang="scss" scoped>
.main {
  margin-top: 60px;

  >div {
    //width: 100%;
    background-size: cover;
  }
}

.top_native {
  height: 504px;
  //background: url(../../assets/img/news/back.jpg) no-repeat center;
  text-align: left;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;

  .newTitle {
    padding: 246px 0 0 180px;
    font-size: 90px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    font-style: italic;
    color: #ffffff;

    span {
      width: 374px;
      height: 85px;
    }
  }
}

.navBar {
  height: 70px;
  background: #f2f5f9;

  .menu {
    margin: 0 180px;
    display: flex;

    .menuItem {
      cursor: pointer;
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      line-height: 67px;
      color: #b5b5b5;
      margin-right: 100px;
      display: flex;

      span {
        &:first-child {
          display: block;
          color: #000;
          margin-right: 5px;
        }
      }
    }

    .active {
      span {
        &:first-child {
          color: #2d72ff;
          font-weight: 600;
          border-bottom: 3px solid #2d72ff;
        }
      }
    }
  }
}

.newsList {
  // height: 1335px;
  background: url(../../assets/img/news/list_back.png) no-repeat center;
  text-align: left;
  font-family: Source Han Sans CN;

  .example {
    padding: 20px 180px;
    display: flex;

    img {
      width: 409px;
      height: 257px;
    }

    .rightCont {
      margin-left: 30px;
    }

    .newTitle {
      display: flex;
      justify-content: space-between;

      img {
        width: 20px;
        height: 27px;
        margin-right: 10px;
        position: relative;
        top: 5px;
      }

      span,
      .time {
        height: 23px;
        font-size: 20px;
        font-weight: 600;
        color: #333333;
        line-height: 27px;
      }

      .time {
        font-weight: normal;
      }
    }

    p {
      width: 1095px;
      height: 174px;
      font-size: 14px;
      color: #6a6a6a;
      line-height: 27px;
      margin-top: 10px;
    }
  }
}
</style>
